// extracted by mini-css-extract-plugin
export default {"screen-content":"AdministrationUserNewScreen_screen-content__OVIQB"};